// Fixed visual marker for manually-created (custom) resources.
// ADMIN-ONLY: distinguishes manual specialists / custom services from
// Medfile-synced records in the admin index lists. Never used on the public
// front, which must render manual and synced resources identically.
export const CUSTOM_RESOURCE_ICON = 'cursor-click';
export const CUSTOM_RESOURCE_LABEL = 'Manualny';
export const CUSTOM_RESOURCE_BADGE_CLASS =
  'inline-flex items-center gap-1.5 rounded-full bg-amber-100 px-2.5 py-1 text-sm font-medium text-amber-800';
export const CUSTOM_RESOURCE_ROW_CLASS =
  'bg-[#f9f5e6] hover:bg-[#f3ecd4] focus-within:bg-[#f3ecd4]';
